module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-200.729207d2.woff2";